import { render, staticRenderFns } from "./adgroup-item.vue?vue&type=template&id=0dcf59f8&scoped=true&"
import script from "./adgroup-item.vue?vue&type=script&lang=js&"
export * from "./adgroup-item.vue?vue&type=script&lang=js&"
import style0 from "./adgroup-item.vue?vue&type=style&index=0&id=0dcf59f8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dcf59f8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VDivider,VSelect,VSwitch,VTooltip})
